
import ZUtil from './zutil';
import ZLog from './zlog';
import ZProps from './zprops';
import ZNetwork from './znetwork';
//import AWS from 'aws-sdk/global'
import AWS from 'aws-sdk'
import AWSMqttClient from 'aws-mqtt'
const production = ZUtil.isProduction();

AWS.config.region="us-west-2";
if (production) {
	AWS.config.credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: 'us-west-2:170f6d94-27ee-4277-b95f-fb6c09e35bcc',
		RoleArn: "arn:aws:iam::978566288268:role/Cognito_AutomaticRealtimeAPIUnauth_Role"
	})
} else {
	AWS.config.credentials = new AWS.CognitoIdentityCredentials({
		IdentityPoolId: 'us-west-2:dd04e7bf-c6ca-46ed-bcd6-a10e0f0f787a',
		RoleArn: "arn:aws:iam::562175205621:role/Cognito_AutomaticAPIUnauth_Role"
	})
}


// https://github.com/kmamykin/aws-mqtt
// This manages both realtime communicatons with API as well as direct invocations
var ZAPI = {
	APIURL: production ? "https://api.automatic.ai" : ZUtil.isStaging() ? "https://api.fab.ai" : "http://192.168.86.216:5013",
	ENDPOINT: production ? "a2ci2h28727pi9-ats.iot.us-west-2.amazonaws.com" : "a23qswvf7cfizr-ats.iot.us-west-2.amazonaws.com",
	connect: function(user_uri, callback) {
		this.setPlatform(ZUtil.getPlatform());
		AWS.config.credentials.get( err => {
			if (err) { 
				console.warn("Get credential failed", err); 
				return; 
			}
			this.client = new AWSMqttClient({
				region: AWS.config.region, 
				credentials: AWS.config.credentials,
				accessKeyId: AWS.config.credentials.accessKeyId,
				secretAccessKey: AWS.config.credentials.secretAccessKey,
				sessionToken: AWS.config.credentials.sessionToken,
				endpoint: this.ENDPOINT,
				expires: 24*60*60, 
				clientId: user_uri + Date.now(), // allows one live browser tab at a time or AWS.config.credentials.identityId,
				will: {
					topic: 'WillMsg',
					payload: 'Connection Closed abnormally..!',
					qos: 0,
					retain: false
					} 
				}
			)
			this._subscribers = {};
			this._logEventsToConsole(this.client);
			this.client.on('message', (topic, payload) => {
				ZLog.debug("ZAPI realtime recieved message " + topic, payload.toString());
				(this._subscribers[topic] || []).forEach( sub => {
					sub(topic, JSON.parse(payload.toString()));
				});
			});
			callback();
		});
	},
	_logEventsToConsole: (client) => {
		client.on('connect', () => ZLog.debug('ZAPI realtime success CONNECT'))
		client.on('offline', () => ZLog.debug('ZAPI realtime OFFLINE'))
		client.on('close', () => ZLog.debug('ZAPI realtime CLOSE'))
		client.on('error', (err) => console.error(err))
		client.on('outgoingEmpty', () => ZLog.debug('ZAPI realtime OUTGOING EMPTY'))
		client.on('reconnect', () => ZLog.debug('ZAPI realtime RECONNECT'))
//		client.on('packetsend', (packet) => ZLog.debug('ZAPI realtime PACKET SEND'))
//		client.on('packetreceive', (packet) => ZLog.debug('ZAPI realtime PACKET RECV'))
	},
	subscribe: function(topic, callback) {
		if (!this._subscribers[topic]) {
			this.client.subscribe(topic);
			this._subscribers[topic] = [];
		}
		this._subscribers[topic].push(callback);
		return { topic: topic, callback: callback };
	},
	unsubscribe: function(topic, callback) {
		if (typeof topic !== "string") {
			callback = topic.callback;
			topic = topic.topic;
		}
		var subs = this._subscribers[topic] || [];
		var unsub = 0;
		for (var i = 0, len = subs.length; i < len; ++i) {
			if (subs[i] === callback) {
				subs.splice(i, 1);
				--i;
				--len;
				++unsub;
			}
		}
		if (unsub === 0) {
			console.error("ZMQTTRealtime.unsubscribe found no such subscriber", topic);
		} else if (subs.length === 0) {
			this.client.unsubscribe(topic);
			delete this._subscribers[topic];
		}
	},
	invoke: function(command, service_uri, payload, callback) {
		if (command !== "capacity") {
			this.startPollingCapacity();
		}
		ZNetwork.ajax({
			type: 'POST', 
			url: this.APIURL + "/v1/handler",
			data: { command: command, service_uri: service_uri, api_token: ZProps.get("user").apikey, payload: payload },
			headers: { "Content-Type": "application/json" },
			cookies: false,
			success: function(result) {
				if (result && typeof result === "string") {
					try { result = JSON.parse(result); } catch (e) { }
				}
				callback(null, result);
			},
			error: function (request, status, err) { 
				if (err && typeof err === "string") {
					try { err = JSON.parse(err); } catch (e) { }
				}
				let message = { name: 'log', level: "error", message: "Failure to execute: " + command, timestamp: Date.now() };
				ZLog.error('ZAPI.invoke error. command: ' + command + ", err: " + ((err && err.message && err.message.message) || err));
				callback("API communication error: " + err + " (" +  JSON.stringify(message) + ")", err);
			}
		});
	},
/*
	invokeOLD: async function(command, service_uri, payload, callback) {
		ZLog.debug("invoke: " + command);
		// generates error (timeout) magically when they return for calls >= ~2 minutes
		return await fetch(this.APIURL + "/v1/handler", { 
			method: "POST", 
//			credentials: 'include',
//			mode: ZUtil.isDevelopment() ? "cors" : "no-cors",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ command: command, service_uri: service_uri, api_token: ZProps.get("user").apikey, payload: payload })
		}).then((response) => {
			// ZLog.log("invoke response=" + response, { response: response.json() });
			try {
console.log("logsss response.status=" + response.status);
				if (response.status >= 400) {
console.log("logsss error=" + response.json());
					callback(response.json());
				} else {
					return response.json();
				}
			} catch (e) {
				ZLog.error("Invalid JSON in response");
				return { error: "Invalid JSON in response: " + response };
			}
		}).then((result) => {
			if (result) {
				ZLog.debug("invoke result=", { result: result });
				callback(null, result);
			}
			//return result;
		}).catch((err) => {
			let message = { level: "error", message: "Failure to execute: " + command };
			ZLog.error('ZAPI.invoke error. command: ' + command + ", err: " + err);
			callback("API communication error: " + err + " (" +  JSON.stringify(message) + ")");
		});
	},
*/
	setPlatform: function(platform) {
		if (platform === "production") {
			this.APIURL = "https://api.automatic.ai";
		} else if (platform === "staging") {
			this.APIURL = "https://api.fab.ai";
		} else { // dev
			this.APIURL = "http://192.168.86.216:5013";
		}
	},
	// higher level api
	getVersion: function(callback) {
		ZAPI.invoke("version", null, { }, (err, version) => {
			callback(err, version && version.version);
		});
	},
	getLogs: function(service, refresh, callback) {
		if (!refresh) {
			let logs = ZProps.get(service.uri + ".logs");
			if (logs) {
				return callback(null, logs);
			}
		}
		ZAPI.invoke("logs", service.uri, { topic: "log" }, (err, list) => {
			let logs = Array.isArray(list) ? list : list ? [list] : [{ timestamp: Date.now(), message: "No logs found" }];
			ZProps.set(service.uri + ".logs", logs);
			callback(err, logs);
		});
	},
	clearLogs: function(service_uri) {
		ZProps.set(service_uri + ".logs", [{ name: "log", message: "clear" }]);
	},
	INIT_CAPACITY_POLLING_TIMEOUT: 60*1000,
	CAPACITY_POLLING_TIMEOUT: 60*1000,
	startPollingCapacity: function() {
		clearTimeout(this.capacity_polling_timeout);
		this.CAPACITY_POLLING_TIMEOUT = this.INIT_CAPACITY_POLLING_TIMEOUT;
		this._pollCapacity();
	},
	_pollCapacity: function() {
		console.log("this.CAPACITY_POLLING_TIMEOUT=" + this.CAPACITY_POLLING_TIMEOUT);
		this.capacity_polling_timeout = setTimeout( () => { 
			ZAPI.getCapacity((err, results) => {
				if (!err) {
					let group = ZProps.get("usergroup");
					if (group.capacity !== results.capacity) {
						group.capacity = results.capacity;
						ZProps.set("usergroup", group);
						this.CAPACITY_POLLING_TIMEOUT = this.INIT_CAPACITY_POLLING_TIMEOUT;
					} else {
						this.CAPACITY_POLLING_TIMEOUT = this.CAPACITY_POLLING_TIMEOUT * 4;
					}
					this._pollCapacity();
				}
			});
		}, this.CAPACITY_POLLING_TIMEOUT );
	},
	getCapacity: function(callback) {
		ZAPI.invoke("capacity", null, {}, callback);
	},
	// has changed since deploy, test, or training
	clearIsOutOfDate: function(service_uri) {
		ZProps.set(service_uri + ".changes", null);
	},
	isOutOfDate: function(service, force, callback) {
		let changes = ZProps.get(service.uri + ".changes");
		if (!force && changes) {
			return callback(null, changes.changed);
		}
		ZAPI.invoke("diff", service.uri, { }, (err, diffs) => {
			if (!err && diffs) {
				ZProps.set(service.uri + ".changes", diffs);
			}
			callback(err, err ? false : diffs.changed);
		});
	}
				
}
export default ZAPI;



// WEBPACK FOOTER //
// ./src/zapi.js